module.exports = __webpack_public_path__ + "img/InfoHover.0e8bd7d6.svg";